/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

function addEventListener(node, event, callback, options) {
  if (!node || !node.addEventListener) {
    return () => {};
  }

  node.addEventListener(event, callback, options);
  return () => {
    node.removeEventListener(event, callback, options);
  };
}

export default addEventListener;
